<!-- Produtos -->
<div class="section-title">
  <mat-icon>inventory_2</mat-icon>
  <span>Produtos</span>
  <span class="status-badge badge-cinza">{{ products.length }}</span>
  @if (!somenteLeitura) {
    <div class="section-title-actions ms-auto">
      @if (!itemAdding) {
        <button mat-button type="button" class="btn-section" (click)="toggleAddingItem()">
          <mat-icon>add</mat-icon>
          Adicionar item
        </button>
      } @else {
        <button mat-button type="button" class="btn-section btn-section--cancel" (click)="toggleAddingItem()">
          <mat-icon>close</mat-icon>
          Cancelar
        </button>
      }
    </div>
  }
</div>

<!-- Mesmo painel do "Adicionar fornecedor" e do "Adicionar item" do Pedido. -->
@if (itemAdding && !somenteLeitura) {
  <div class="ced-cot-add">
    <div class="ced-cot-add__head">
      <mat-icon class="material-symbols-outlined">{{ avulsoMode ? 'edit_note' : 'add_shopping_cart' }}</mat-icon>
      <span>{{ avulsoMode ? 'Adicionar produto avulso' : 'Adicionar item' }}</span>
      <span class="ced-section-spacer"></span>
      <button type="button" class="ced-cot-add__close" (click)="toggleAddingItem()" matTooltip="Fechar">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
    <div class="ced-cot-add__body">
      @if (!avulsoMode) {
        <app-ced-busca-produto [itensAdicionados]="products" (produtoSelecionado)="addProductFromSearch($event)"></app-ced-busca-produto>
        <div class="ced-add-rodape">
          <div class="ced-cot-add__hint">
            <mat-icon class="material-symbols-outlined">info</mat-icon>
            Não encontrou no cadastro? Adicione como avulso; ele precisa ser vinculado ao cadastro antes do Pedido.
          </div>
          <button mat-button type="button" class="btn-section" (click)="startAvulso()">
            <mat-icon>edit_note</mat-icon>
            Adicionar como avulso
          </button>
        </div>
      } @else {
        <div class="ced-avulso-grid">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="ced-avulso-desc">
            <mat-label>Descrição do produto</mat-label>
            <input #avulsoDescInput matInput [(ngModel)]="avulsoName" placeholder="Ex.: Cadeira ergonômica modelo X"
              (keydown.enter)="confirmAvulso()">
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Unidade</mat-label>
            <mat-select [(ngModel)]="avulsoUnit">
              @for (u of unitOpts; track u.value) {
                <mat-option [value]="u.value">{{ u.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="ced-avulso-obs">
            <mat-label>Observação (opcional)</mat-label>
            <input matInput [(ngModel)]="avulsoNote" placeholder="Modelo, fornecedor sugerido, link…"
              (keydown.enter)="confirmAvulso()">
          </mat-form-field>
        </div>
        <div class="ced-avulso-actions">
          <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelAvulso()">
            <mat-icon>arrow_back</mat-icon>
            Voltar à busca
          </button>
          <button mat-flat-button type="button" class="btn-primary" [disabled]="!avulsoValid" (click)="confirmAvulso()">
            <mat-icon>add</mat-icon>
            Adicionar
          </button>
        </div>
      }
    </div>
  </div>
}

@if (products.length === 0) {
  <app-empty-state
    icon="inventory_2"
    title="Nenhum item adicionado."
    [subtitle]="somenteLeitura ? '' : 'Use “Adicionar item” para incluir produtos do cadastro ou um produto avulso.'">
  </app-empty-state>
} @else {
  @for (p of products; track $index) {
    <div class="ced-product-card">
      <div class="ced-prod-head">
        <span class="ced-product-icon">
          <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
        </span>
        <div class="ced-product-info">
          <div class="ced-product-name">
            {{ p.name }}
            @if (p.isAvulso) {
              <span class="status-badge badge-cinza item-badge" matTooltip="Produto não cadastrado no estoque">Avulso</span>
            }
          </div>
          <div class="ced-product-sku">
            @if (p.isAvulso) {
              Produto não cadastrado@if (p.observacao) { · {{ p.observacao }} }
            } @else {
              SKU {{ p.sku }}@if (p.marca) { · {{ p.marca }} }
            }
          </div>
        </div>
        @if (!somenteLeitura) {
          <button type="button" mat-icon-button class="btn-remover" (click)="removeProduct(p)" matTooltip="Remover">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
          </button>
        }
      </div>
      <div class="ced-product-grid">
        <div>
          <span class="ced-mini-label">Quantidade</span>
          <div class="ced-qty-control">
            <input
              class="ced-qty-input"
              [currencyMask]="quantidadeMask"
              [ngModel]="p.qty"
              (ngModelChange)="updateQuantity(p, $event)"
              [readonly]="somenteLeitura"
              [attr.aria-label]="'Quantidade de ' + p.name">
            <small>{{ p.unit }}</small>
          </div>
        </div>
        <div>
          <span class="ced-mini-label">Estoque</span>
          <span class="ced-mini-val" [class.ced-warn]="isLowStock(p)" [class.ced-ok]="p.stock != null && !isLowStock(p)">
            {{ p.stock != null ? p.stock : '—' }}
            @if (isLowStock(p)) {
              <mat-icon class="material-symbols-outlined" matTooltip="Abaixo do solicitado">warning</mat-icon>
            }
          </span>
        </div>
        <div>
          <span class="ced-mini-label">Preço da última compra</span>
          <span class="ced-mini-val">{{ p.isAvulso || p.price === '—' ? '—' : 'R$ ' + p.price }}</span>
        </div>
      </div>
    </div>
  }
}

<div class="ced-total-row">
  <span>Total de itens</span>
  <span class="ced-total-val">{{ totalQty | number: formatoQuantidade }} {{ unidadeTotal }}</span>
</div>
